// Client de la page Audit : le journal paginé AVEC les axes de filtre serveur (acteur, niveau,
// type, période, texte) et la lecture d'une version de contenu (pour « Voir le diff complet »).
// Axios manuscrit (comme activityFeedClient) : le bearer Auth0 s'applique en déployé et on évite
// une régénération swagger pour des query params.
import axios from "axios";
import type { LogEntry } from "../../API/Models";
import { buildAuditParams, type AuditFilters } from "./auditQuery";

export { buildAuditParams, dayToIsoSince, dayToIsoUntil } from "./auditQuery";
export type { AuditFilters } from "./auditQuery";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export interface AuditPage {
	items: LogEntry[];
	total: number;
	page: number;
	pageSize: number;
}

export interface ContentVersionInfo {
	id: number;
	contentId: string;
	schemaKey?: string;
	language?: string;
	authorEmail?: string;
	changeSummary?: string;
	action?: string;
	createdAt?: string;
}

export interface ContentVersionDetail {
	version: ContentVersionInfo;
	data: unknown;
}

export const auditClient = {
	/** Une page du journal, filtrée SERVEUR : le client pagine un journal filtré, il ne filtre pas une page. */
	paged: async (page: number, pageSize: number, filters: AuditFilters): Promise<AuditPage> => {
		const r = await axios.get<AuditPage>(`${apiBase}/api/logs/paged`, {
			params: buildAuditParams(page, pageSize, filters),
			withCredentials: true
		});
		return r.data;
	},
	/** Un instantané de version avec sa donnée complète, pour le diff avant/après d'une entrée. */
	version: async (contentId: string, versionId: number): Promise<ContentVersionDetail> => {
		const r = await axios.get<ContentVersionDetail>(
			`${apiBase}/api/content/${encodeURIComponent(contentId)}/versions/${versionId}`,
			{ withCredentials: true }
		);
		return r.data;
	},
	/** Une archive d'artefact DÉPLOYÉ avec son payload complet, pour le diff d'une entrée de déploiement. */
	artifact: async (contentId: string, artifactId: number): Promise<ContentVersionDetail> => {
		const r = await axios.get<{ artifact: ContentVersionInfo; data: unknown }>(
			`${apiBase}/api/content/${encodeURIComponent(contentId)}/artifacts/${artifactId}`,
			{ withCredentials: true }
		);
		return { version: r.data.artifact, data: r.data.data };
	}
};

export default auditClient;
